import React from 'react'

import { getStatusTagColor } from './helpers'

import { Container, StatusTag } from './styles'

const Status: React.FC<StatusProps> = ({
  onlyBullet,
  label,
  status = {},
  template
}) => {
  const { label: labelStatus = null, type = null, tagColor } = status
  const text = label || labelStatus

  if (onlyBullet || !text) {
    return <Container type={type} onlyBullet template={template} />
  }

  /**
   * `template` é a prop pela qual o chamador diz "ignore o dado, pinte assim",
   * então ela continua sendo a última palavra. O `tagColor` vem de dentro do
   * `status`, derivado do dado, e só decide quando ninguém sobrescreveu — do
   * contrário a cor explícita perderia para o dicionário de status, e quem
   * tentasse sobrescrever a cor de um status que tem `tagColor` não entenderia
   * por que não funciona.
   */
  const color = template
    ? getStatusTagColor(template)
    : tagColor || getStatusTagColor(type)

  return (
    <StatusTag variant="secondary" color={color} title={text}>
      {text}
    </StatusTag>
  )
}

export default Status
